import { render, staticRenderFns } from "./VerifyEmailLayout.vue?vue&type=template&id=89482e4e&"
import script from "./VerifyEmailLayout.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports